import { stripSearchParams } from "@tanstack/react-router";
import { useState } from "react";
import * as v from "valibot";

import { ErrorPage500 } from "@/components/error-page-500";
import FullscreenLoader from "@/components/fullscreen-loader";

// returned error from auth0 example
// authorize?error=access_denied&error_description=socket%20hang%20up&state=Q2cta1JHfllYS3VFaG1yOHJEM2lxYldoeUNsQkUzc2JJSl9RSzRSeENsXw%3D%3D
const searchDefaults = {
  error: "Authentication Error",
  error_description:
    "Something went wrong authenticating your user. If this continues please open a support ticket.",
};

const SearchSchema = v.object({
  error: v.optional(v.fallback(v.string(), searchDefaults.error), searchDefaults.error),
  error_description: v.optional(
    v.fallback(v.string(), searchDefaults.error_description),
    searchDefaults.error_description,
  ),
});

export const Route = createFileRoute({
  component: RouteComponent,
  search: {
    middlewares: [stripSearchParams(searchDefaults)],
  },
  validateSearch: SearchSchema,
});

function RouteComponent() {
  const [timestamp] = useState(new Date());
  const { error, error_description } = Route.useSearch();

  if (error) {
    return (
      <ErrorPage500
        requestId={"AUTH"}
        timestamp={timestamp}
        details={[{ label: error, value: error_description }]}
      />
    );
  }

  return <FullscreenLoader />;
}
